import { render, staticRenderFns } from "./ArticleBar.vue?vue&type=template&id=b2e9b84a&scoped=true&"
import script from "./ArticleBar.vue?vue&type=script&lang=js&"
export * from "./ArticleBar.vue?vue&type=script&lang=js&"
import style0 from "./ArticleBar.vue?vue&type=style&index=0&id=b2e9b84a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2e9b84a",
  null
  
)

export default component.exports